import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "ArrowUp"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M488.992 344L148.992 700.992q-8.992 10.016-8.992 22.016t8.992 22.016v0.992q8.992 8.992 21.504 8.992T192 746.016l320-336 320 336q8.992 8.992 21.504 8.992t21.504-8.992v-0.992q8.992-10.016 8.992-22.016t-8.992-22.016L535.008 344q-8.992-8.992-23.008-8.992t-23.008 8.992z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var arrowUp = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\arrow-up.vue"]]);

export { arrowUp as default };
